// dashboards-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "% da base ativa": "% de la base activa",
    "/mês em jogo": "/mes en juego",
    "1 abastecimento a cada": "1 carga de combustible cada",
    "24h": "24h",
    "30 dias": "30 días",
    "45 subprojetos · documentação interna · admin only · embed JWT-protegido": "45 subproyectos · documentación interna · admin only · embed protegido con JWT",
    "7 dias": "7 días",
    "A IA leu os comentários e identificou estes tópicos. O \"gap\" mostra quantos clientes escreveram algo relacionado mas não marcaram o pollItem no app.": "La IA leyó los comentarios e identificó estos temas. El \"gap\" muestra cuántos clientes escribieron algo relacionado pero no marcaron el pollItem en la aplicación.",
    "A primeira carga da rede leva alguns minutos.": "La primera carga de la red toma unos minutos.",
    "ADMIN": "ADMIN",
    "Acesso não autorizado": "Acceso no autorizado",
    "Acesso restrito a administradores.": "Acceso restringido a administradores.",
    "Adicionar contato": "Agregar contacto",
    "Adicione ao menos um contato padrão para ativar os envios.": "Agregue al menos un contacto predeterminado para activar los envíos.",
    "Ainda não há clientes suficientes.": "Todavía no hay clientes suficientes.",
    "Ainda não há histórico suficiente para cohorts.": "Todavía no hay historial suficiente para cohortes.",
    "Alertar sobre esta integração": "Alertar sobre esta integración",
    "Alertas de falha das integrações": "Alertas de falla de las integraciones",
    "Alertas de falha por WhatsApp": "Alertas de falla por WhatsApp",
    "Análise já em andamento. Aguarde alguns instantes.": "Análisis ya en curso. Espere unos instantes.",
    "Baseado nos pollItems selecionados pelos clientes. Mínimo 10 avaliações no período.": "Basado en los pollItems seleccionados por los clientes. Mínimo 10 evaluaciones en el período.",
    "Cada R$ 1 em desconto de recuperação trouxe": "Cada R$ 1 en descuento de recuperación trajo",
    "Campanha (gift)": "Campaña (gift)",
    "Campo em branco herda o padrão acima.": "El campo en blanco hereda el valor predeterminado de arriba.",
    "Carregando hub...": "Cargando hub...",
    "Ciclo de vida da base": "Ciclo de vida de la base",
    "Clicadas": "Clicadas",
    "Concedidos": "Otorgados",
    "Configurar alertas": "Configurar alertas",
    "Configuração de alertas salva": "Configuración de alertas guardada",
    "Contatos padrão": "Contactos predeterminados",
    "Cooldown (min)": "Cooldown (min)",
    "Criar regra de recuperação →": "Crear regla de recuperación →",
    "Cupons afetados": "Cupones afectados",
    "Cupons gerados": "Cupones generados",
    "Custo dos prêmios": "Costo de los premios",
    "Desligado, o worker continua rodando mas nenhuma mensagem é enviada.": "Apagado, el worker sigue funcionando pero no se envía ningún mensaje.",
    "Dias": "Días",
    "Dispara o worker para analisar comentários pendentes dos últimos N dias.": "Ejecuta el worker para analizar comentarios pendientes de los últimos N días.",
    "Divergência por Posto": "Divergencia por estación",
    "Enviadas": "Enviadas",
    "Enviar alertas": "Enviar alertas",
    "Erros das Integrações de Cupom": "Errores de las integraciones de cupón",
    "Esta semana na sua rede": "Esta semana en su red",
    "Evolução da frequência de seleção por semana": "Evolución de la frecuencia de selección por semana",
    "Falhas": "Fallas",
    "Falhas mínimas": "Fallas mínimas",
    "Falhas na geração de código no resgate (RTI / EVO / Trevo / Teixeira Pinto / Sanvitron) — para recuperar e resolver. Apenas erros são registrados.": "Fallas en la generación de código en el canje (RTI / EVO / Trevo / Teixeira Pinto / Sanvitron) — para recuperar y resolver. Solo se registran los errores.",
    "Falhas no período": "Fallas en el período",
    "Falhas por integração": "Fallas por integración",
    "Falhas recentes": "Fallas recientes",
    "Fatia que mais saiu:": "Sector que más salió:",
    "Ferramentas de engajamento": "Herramientas de interacción",
    "Fidelidade — seus clientes estão voltando?": "Fidelidad — ¿sus clientes están regresando?",
    "Frentistas — Destaques e Alertas": "Playeros — Destacados y alertas",
    "Frequência média:": "Frecuencia media:",
    "Girados": "Girados",
    "IA": "IA",
    "Indicados no período": "Referidos en el período",
    "Inscritos": "Inscritos",
    "Instalação": "Instalación",
    "Já abasteceram": "Ya cargaron combustible",
    "Latência": "Latencia",
    "Latência média": "Latencia media",
    "Latência p95": "Latencia p95",
    "Leitura da IA": "Lectura de la IA",
    "Lidas": "Leídas",
    "Mais elogiados": "Más elogiados",
    "Motivo": "Motivo",
    "Nenhum cliente selecionou pollItems no período. Verifique se a rede tem pollItems cadastrados.": "Ningún cliente seleccionó pollItems en el período. Verifique si la red tiene pollItems registrados.",
    "Nenhum cliente valioso esfriou. 👏 Sua base de maior valor segue ativa.": "Ningún cliente valioso se enfrió. 👏 Su base de mayor valor sigue activa.",
    "Nenhum comentário requer atenção no período": "Ningún comentario requiere atención en el período",
    "Nenhum dado no período": "Ningún dato en el período",
    "Nenhum dado para este posto": "Ningún dato para esta estación",
    "Nenhum giro concedido no período.": "Ningún giro otorgado en el período.",
    "Nenhum posto com dados suficientes para comparar": "Ninguna estación con datos suficientes para comparar",
    "Nenhuma avaliação no período.": "Ninguna evaluación en el período.",
    "Nenhuma conquista no período.": "Ningún logro en el período.",
    "Nenhuma falha no período. 🎉": "Ninguna falla en el período. 🎉",
    "Nome do template (Meta)": "Nombre de la plantilla (Meta)",
    "Nota do Cliente": "Nota del cliente",
    "Nota do Cliente × Leitura da IA": "Nota del cliente × lectura de la IA",
    "Nota do cliente, leitura da IA e tags selecionadas — tudo num lugar só": "Nota del cliente, lectura de la IA y etiquetas seleccionadas — todo en un solo lugar",
    "Não foi possível carregar a configuração de alertas": "No fue posible cargar la configuración de alertas",
    "Não foi possível carregar os dados.": "No fue posible cargar los datos.",
    "Números gerados": "Números generados",
    "O que elogiam": "Lo que elogian",
    "O que elogiam × O que reclamam": "Lo que elogian × lo que reclaman",
    "O que merece sua atenção": "Lo que merece su atención",
    "O que reclamam": "Lo que reclaman",
    "O que seus clientes mais falam": "Lo que más dicen sus clientes",
    "Ordem: maior divergência entre nota e sentimento → risco silencioso no topo": "Orden: mayor divergencia entre nota y sentimiento → riesgo silencioso arriba",
    "Participantes": "Participantes",
    "Payload": "Payload",
    "Payload —": "Payload —",
    "PontuaX Ecosystem": "PontuaX Ecosystem",
    "PontuaX Ecosystem Hub": "PontuaX Ecosystem Hub",
    "Por integrador (opcional)": "Por integrador (opcional)",
    "Positivos": "Positivos",
    "Posto / Rede": "Estación / Red",
    "Postos afetados": "Estaciones afectadas",
    "Postos que mais falham": "Estaciones que más fallan",
    "Precisam de atenção": "Necesitan atención",
    "Preencha após aprovar o template na Meta. Vazio = nenhum alerta é enviado.": "Complete después de aprobar la plantilla en Meta. Vacío = no se envía ninguna alerta.",
    "Preencha o nome do template da Meta para ativar os envios.": "Complete el nombre de la plantilla de Meta para activar los envíos.",
    "Preparando os dados de fidelidade…": "Preparando los datos de fidelidad…",
    "Processar comentários (admin)": "Procesar comentarios (admin)",
    "Pulse de Sentimento por Posto": "Pulso de sentimiento por estación",
    "Quando": "Cuándo",
    "Recarregar hub": "Recargar hub",
    "Recebidas": "Recibidas",
    "Receita em risco": "Ingresos en riesgo",
    "Receita pós-volta": "Ingresos post-regreso",
    "Remover contato": "Quitar contacto",
    "Requerem Atenção": "Requieren atención",
    "Retenção por safra de clientes": "Retención por cohorte de clientes",
    "Satisfação Geral": "Satisfacción general",
    "Segmentos de valor (RFM)": "Segmentos de valor (RFM)",
    "Selecione o início e o fim do período para carregar os dados.": "Seleccione el inicio y el fin del período para cargar los datos.",
    "Selecione o posto": "Seleccione la estación",
    "Selecione um posto para ver os canônicos": "Seleccione una estación para ver los canónicos",
    "Sem dados de segmentação ainda.": "Aún no hay datos de segmentación.",
    "Sentimento": "Sentimiento",
    "Silêncio após avisar": "Silencio después de avisar",
    "Só alerta a partir de N falhas pendentes": "Solo alerta a partir de N fallas pendientes",
    "Tags da IA — o que os clientes escreveram": "Etiquetas de la IA — lo que los clientes escribieron",
    "Tags selecionadas pelos clientes após dar a nota": "Etiquetas seleccionadas por los clientes después de calificar",
    "Tendência dos últimos 12 semanas": "Tendencia de las últimas 12 semanas",
    "Todas as integrações": "Todas las integraciones",
    "Token atual do posto": "Token actual de la estación",
    "Total de avaliações no período": "Total de evaluaciones en el período",
    "Total de avaliações que possuem comentário analisado no período": "Total de evaluaciones que tienen comentario analizado en el período",
    "Ver detalhes": "Ver detalles",
    "Ver mais (": "Ver más (",
    "Você não tem permissão para acessar o Dashboard de Comentários.": "Usted no tiene permiso para acceder al panel de comentarios.",
    "Voz do Cliente": "Voz del cliente",
    "Voz do Cliente · IA": "Voz del cliente · IA",
    "WhatsApp": "WhatsApp",
    "amostras": "muestras",
    "avaliações": "evaluaciones",
    "clientes de alto valor pararam de voltar — ainda recuperáveis": "clientes de alto valor dejaron de volver — todavía recuperables",
    "clientes na base": "clientes en la base",
    "comentários no período — sentimento ainda não analisado pela IA.": "comentarios en el período — sentimiento aún no analizado por la IA.",
    "de 5": "de 5",
    "de volta": "de vuelta",
    "desligado": "apagado",
    "dos clientes saíram satisfeitos": "de los clientes quedaron satisfechos",
    "exigem atenção": "requieren atención",
    "inferidos": "inferidos",
    "já inativos há mais tempo (mais difíceis de reverter)": "ya inactivos desde hace más tiempo (más difíciles de revertir)",
    "menções": "menciones",
    "negativo (": "negativo (",
    "neutro (": "neutro (",
    "positivo (": "positivo (",
    "posto": "estación",
    "restantes)": "restantes)",
    "ver": "ver",
    "vs período anterior": "vs período anterior",
    "x)": "x)",
    "· Negativos": "· Negativos",
    "· Neutros": "· Neutros",
    "⭐ Avaliações": "⭐ Evaluaciones",
    "🎁 Clube de Vantagens": "🎁 Club de Beneficios",
    "🎟️ Sorteios": "🎟️ Sorteos",
    "🎡 Roleta da Sorte": "🎡 Ruleta de la Suerte",
    "📲 Notificações push": "📲 Notificaciones push",
    "🔄 Recuperação de inativos": "🔄 Recuperación de inactivos",
    "🔴 Críticas": "🔴 Críticas",
    "🟢 Elogios": "🟢 Elogios",
    "🤝 Indicações": "🤝 Referidos",
};

export default catalogo;
